import React from 'react';
import './Hero_parselings.css';

import handsImg from '../../../assets/images/parselings/hands.png';
import handsWebp from '../../../assets/images/parselings/hands.webp';
import parseLingsTitle from '../../../assets/images/parselings/parselings_title.png';
import parseLingsTitleWebp from '../../../assets/images/parselings/parselings_title.webp';
import slimeCenter from '../../../assets/images/parselings/slime_center.png';
import slimeCenterWebp from '../../../assets/images/parselings/slime_center.webp';
import slimeFarRight from '../../../assets/images/parselings/slime_farright.png';
import slimeFarRightWebp from '../../../assets/images/parselings/slime_farright.webp';
import slimeLeft from '../../../assets/images/parselings/slime_left.png';
import slimeLeftWebp from '../../../assets/images/parselings/slime_left.webp';
import slimeRight from '../../../assets/images/parselings/slime_right.png';
import slimeRightWebp from '../../../assets/images/parselings/slime_right.webp';

const MatrixBackground = () => {
  const [matrix, setMatrix] = React.useState([]);
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

  const generateMatrix = () => {
    const rows = 14;
    const cols = 35;
    return Array(rows).fill().map(() => 
      Array(cols).fill().map(() => 
        characters.charAt(Math.floor(Math.random() * characters.length))
      )
    );
  };

  React.useEffect(() => {
    setMatrix(generateMatrix());

    const interval = setInterval(() => {
      setMatrix(prevMatrix => {
        const newMatrix = [...prevMatrix];
        const randomRow = Math.floor(Math.random() * 14);
        const randomCol = Math.floor(Math.random() * 35);
        const randomChar = characters.charAt(Math.floor(Math.random() * characters.length));
        
        newMatrix[randomRow] = [
          ...newMatrix[randomRow].slice(0, randomCol),
          randomChar,
          ...newMatrix[randomRow].slice(randomCol + 1)
        ];
        
        return newMatrix;
      });
    }, 100);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="matrix-background">
      {matrix.map((row, i) => (
        <div key={i} className="matrix-row">
          {row.map((char, j) => (
            <span key={`${i}-${j}`} className="matrix-char">{char}</span>
          ))}
        </div>
      ))}
    </div>
  );
};

const Hero = () => {
  return (
    <div className="hero-parselings-container">
      <MatrixBackground />
      <div className="left-side">
        <picture className="hands">
          <source srcSet={handsWebp} type="image/webp" />
          <img src={handsImg} alt="Hands" />
        </picture>

        <div className="slimes-container">
          <div className="slime-wrapper slime-left">
            <picture className="slime">
              <source srcSet={slimeLeftWebp} type="image/webp" />
              <img src={slimeLeft} alt="Left Slime" />
            </picture>
          </div>
          <div className="slime-wrapper slime-center">
            <picture className="slime">
              <source srcSet={slimeCenterWebp} type="image/webp" />
              <img src={slimeCenter} alt="Center Slime" />
            </picture>
          </div>
          <div className="slime-wrapper slime-right">
            <picture className="slime">
              <source srcSet={slimeRightWebp} type="image/webp" />
              <img src={slimeRight} alt="Right Slime" />
            </picture>
          </div>
          <div className="slime-wrapper slime-far-right">
            <picture className="slime">
              <source srcSet={slimeFarRightWebp} type="image/webp" />
              <img src={slimeFarRight} alt="Far Right Slime" />
            </picture>
          </div>
        </div>
      </div>

      <picture className="game-title">
        <source srcSet={parseLingsTitleWebp} type="image/webp" />
        <img src={parseLingsTitle} alt="Parselings Title" />
      </picture>
    </div>
  );
};

export default Hero;